// extracted by mini-css-extract-plugin
module.exports = {"textSection":"Footer_textSection__EUWpX","section":"Footer_section__1BW2Z","narrow_hide":"Footer_narrow_hide__3a_vJ"};